import moment from 'moment-timezone'
export var dateMixin = {

  data(){
    return{
      
    }
  },


  methods: {

    formatDateTime(dt,includeYear=true){ //TODO timezone und dooeplte impl checken -> wird in solutionMixin verwendet und nicht diese hier
      let options = { month: 'numeric', day: 'numeric',hour:'numeric',minute:'numeric'};
      if(includeYear){
        options['year']='numeric';
      }
      return new Date(dt).toLocaleDateString('de-DE', options)
    },

    dateInXDays(days) {
      let result = new Date();
      result.setDate(result.getDate() + days);
      return result;
    },
    getCurrentDateTimeWithOffset(offsetInS,timezone){ 
      let date= new Date(new Date().getTime() + offsetInS*1000);
      return moment.tz(date, timezone).format();
    },
    universalizeDate(date,timezone){
      return moment.tz(date, timezone).format();
    }
  }
}
